// @ts-nocheck
// TODO: tighten types after migration
import React from 'react';
import './BookLoader.css';
import ProgressBorder from './ProgressBorder';


const BookLoader = ({ progress: externalProgress }) => {
    const [internalProgress, setInternalProgress] = React.useState(0);

    React.useEffect(() => {
        // If external progress is provided, don't simulate
        if (typeof externalProgress === 'number') return;

        const interval = setInterval(() => {
            setInternalProgress(prev => {
                if (prev >= 90) return prev; // Stall at 90% until unmount/done
                // Fast at first, then slower
                const increment = prev < 50 ? 5 : prev < 80 ? 2 : 0.5;
                return Math.min(prev + increment, 90);
            });
        }, 100);

        return () => clearInterval(interval);
    }, [externalProgress]);

    const activeProgress = typeof externalProgress === 'number' ? externalProgress : internalProgress;


    return (
        <div className="fixed top-0 left-0 w-full h-full bg-white flex justify-center items-center z-[9999]">
            <div className="book-loader w-[200px] h-[140px] bg-[#979794] box-border relative rounded-lg" style={{ perspective: '1000px' }}>
                <ProgressBorder
                    width={200}
                    height={140}
                    borderRadius={8}
                    progress={activeProgress}
                />
            </div>
        </div>
    );
};

export default BookLoader;
